const alphabet = [
  'num',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

const displayAlphabet = ({ nav } = { nav: false }) =>
  nav ? ['0-9', '', ...alphabet.slice(1)] : ['0-9', ...alphabet.slice(1)];

export { alphabet, displayAlphabet };
